var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ape3tqdet)",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.14 20.71c-.2.18-.45.29-.71.29h-23.8c-.52 0-.81-.56-.5-.96l4.65-4.74c.2-.19.45-.3.71-.3h23.88c.52 0 .81.57.5.96l-4.73 4.75Z",
    fill: "url(#bpe3tqdet)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.14 40.72c-.2.18-.45.28-.72.28h-23.8c-.5 0-.8-.56-.5-.96l4.66-4.75c.2-.19.45-.29.71-.29h23.88c.52 0 .81.57.5.96l-4.73 4.76Z",
    fill: "url(#cpe3tqdet)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.14 25.28c-.2-.18-.45-.28-.72-.28h-23.8c-.5 0-.8.56-.5.96l4.66 4.75c.2.18.45.29.71.29h23.88c.52 0 .81-.57.5-.96l-4.73-4.76Z",
    fill: "url(#dpe3tqdet)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ape3tqdet",
    x1: 10.42,
    y1: 9.71,
    x2: 68.15,
    y2: 76.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06060A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bpe3tqdet",
    x1: 14.06,
    y1: 23.44,
    x2: 41.45,
    y2: 15.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E73E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#41B8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#27E2B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16FC99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cpe3tqdet",
    x1: 12.39,
    y1: 40.04,
    x2: 43.61,
    y2: 35.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E48FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8D4DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6B7AE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#45B3CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dpe3tqdet",
    x1: 14.18,
    y1: 28,
    x2: 42.42,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8654F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#549AD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#26D9B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolLogo);
export default __webpack_public_path__ + "static/media/sol-logo.d0a7c51b70b1e548e359d27444b47b03.svg";
export { ForwardRef as ReactComponent };